import React, { useState, useRef, useEffect } from 'react';
import './FeatureSection.css';
import VerticalDecoration from '../components/VerticalDecoration/VerticalDecoration';

// Importez vos images ici
import appsImage from '../assets/images/feat-2.png';
import entertainmentImage from '../assets/images/feat-1.png';
import photosImage from '../assets/images/feat.png';
import connectionImage from '../assets/images/feat-2.png';

const features = [
  {
    id: 'Navigation Frictionless',
    title: 'Navigation Frictionless',
    subtitle: "Navigation Bionique. Sans compromis.",
    heading: "Navigation Bionique. Sans compromis.",
    description: "Conçu pour les environnements sensibles. Le système Lidar 3D assure un déplacement autonome et fluide, permettant un bilan complet de la serre sans perturber une seule plante. Optimisez la cartographie des cultures sans effort.",
    category: 'Navigation Frictionless',
    image: appsImage
  },
  {
    id: 'Diagnostic Multi-Spectral',
    title: 'Diagnostic Multi-Spectral',
    subtitle: 'Computer Vision & Diagnostic Multi-Spectral',
    heading: 'Computer Vision & Diagnostic Multi-Spectral.',
    description: "Voit ce que l'humain manque. L'IA de Computer Vision analyse les données multi-spectrales pour identifier les maladies et carences avec une précision chirurgicale, augmentant ainsi le taux de réussite de vos récoltes.",
    category: 'Diagnostic Multi-Spectral',
    image: entertainmentImage
  },
  {
    id: 'Télémétrie de Serre',
    title: 'Télémétrie de Serre',
    subtitle: "Système IoT Intégré & Télémétrie de Serre.",
    heading: "Système IoT Intégré & Télémétrie de Serre.",
    description: "Chaque serre devient un point de données intelligent. Des capteurs IoT collectent en continu la température, l'humidité et les anomalies. La télémétrie en temps réel vous donne la maîtrise totale de l'environnement, où que vous soyez.",
    category: 'Télémétrie de Serre',
    image: photosImage
  },
  {
    id: 'Workflow Automation',
    title: 'Workflow Automation',
    subtitle: "Workflow Automation & Reporting Predictif.",
    heading: "Workflow Automation & Reporting Predictif.",
    description:  "Gèrer ses propres missions. Définissez vos objectifs, et le Workflow Automation prend le relais : navigation autonome, détection proactive et Reporting Predictif généré automatiquement. Un niveau de gestion jamais atteint.",
    category: 'Workflow Automation',
    image: connectionImage
  }
];

const FeatureSection = () => {
  const [activeFeature, setActiveFeature] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handlePrevious = () => {
    setActiveFeature((prev) => (prev > 0 ? prev - 1 : features.length - 1));
  };

  const handleNext = () => {
    setActiveFeature((prev) => (prev < features.length - 1 ? prev + 1 : 0));
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!isMobile) return;
    
    const swipeThreshold = 50;
    const diff = touchStartX.current - touchEndX.current;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swipe gauche - next
        handleNext();
      } else {
        // Swipe droite - previous
        handlePrevious();
      }
    }
  };

  return (
    <section className="features-section" id="features">
      <div className="features-container">
        <VerticalDecoration text={features[activeFeature].category} />
        <div 
          className="features-content"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div className="feature-text">
            <h2>{features[activeFeature].heading}</h2>
            <p>{features[activeFeature].description}</p>
          </div>

          <div className="feature-image">
            <div className="feature-image-wrapper">
              <img 
                src={features[activeFeature].image}
                alt={features[activeFeature].heading}
                className="feature-img"
              />
            </div>
          </div>
        </div>

        {/* Indicateurs de pagination pour mobile */}
        {isMobile && (
          <div className="mobile-pagination">
            {features.map((_, index) => (
              <button
                key={index}
                className={`pagination-dot ${activeFeature === index ? 'active' : ''}`}
                onClick={() => setActiveFeature(index)}
                aria-label={`Go to feature ${index + 1}`}
              />
            ))}
          </div>
        )}

        {/* Navigation desktop/tablet uniquement */}
        <div className="features-nav">
          <button 
            className="nav-arrow nav-arrow-left" 
            onClick={handlePrevious}
            aria-label="Previous feature"
          >
            ←
          </button>

          {features.map((feature, index) => (
            <button
              key={feature.id}
              className={`feature-nav-item ${activeFeature === index ? 'active' : ''}`}
              onClick={() => setActiveFeature(index)}
            >
              <span className="nav-title">{feature.title}</span>
              <span className="nav-subtitle">{feature.subtitle}</span>
            </button>
          ))}

          <button 
            className="nav-arrow nav-arrow-right" 
            onClick={handleNext}
            aria-label="Next feature"
          >
            →
          </button>
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;